module.exports = __webpack_public_path__ + "img/file-ftp.a5ccd58f.svg";